import React, { useState, useEffect } from 'react';
import { Controller, useForm } from "react-hook-form";
import ReactQuill from "react-quill";
import { formats, modules } from "../../utils/editor-tool-options";
import TextEditor from '../../utils/text-editor';
import Sidebars from '../../components/sidebars/Sidebars';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import { toast } from "react-toastify";
import { useGetStaticContentByTypeQuery, useUpdateStaticContentMutation } from '../../Services/StaticContentApi';
import Loader from '../../components/Loader';

const EligibilityShopping = () => {
  const { control, handleSubmit, formState: { errors }, setValue } = useForm();

  // Fetch existing terms content
  const { data: contentData, isLoading } = useGetStaticContentByTypeQuery("eligibility-shopping");
  const [updateContent, { isLoading: isUpdating }] = useUpdateStaticContentMutation();
  const [media, setMedia] = useState(null);
  const [fileType, setFileType] = useState('image');

  const handleMediaChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMedia(file);
      // Determine file type
      if (file.type.startsWith('video/')) {
        setFileType('video');
      } else if (file.type.startsWith('image/')) {
        setFileType('image');
      }
    }
  };

  // Pre-fill form when data arrives
  useEffect(() => {
    const payload =
      contentData?.data?.data ??
      contentData?.data ??
      contentData ??
      null;

    if (!payload) return;

    const record =
      payload?.contents !== undefined
        ? payload
        : payload?.eligibilityShopping ??
          payload?.content ??
          payload?.staticContent ??
          payload?.result ??
          null;

    if (!record) return;

    setValue("content", record?.contents || "");
    setMedia(record?.fileUrl || "");
    setFileType(record?.fileType || "image");
  }, [contentData, setValue]);

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("type", "eligibility-shopping");
    formData.append("contents", data.content);
    formData.append("fileType", fileType);
    if (media) {
      formData.append("fileUrl", media);
    }
    try {
      const res = await updateContent(formData);
      const saved =
        res?.data?.statusCode === 200 ||
        res?.data?.success === true ||
        res?.data?.data?.statusCode === 200 ||
        res?.data?.data?.success === true ||
        res?.statusCode === 200 ||
        res?.success === true;

      if (saved) {
        toast.success("UPDATED SUCCESSFULLY");
      } else {
        toast.error(
          res?.data?.message ||
          res?.message ||
          "Failed to update content"
        );
      }
    } catch (err) {
      toast.error("Error occurred while updating content");
    }
  };

  const renderMediaPreview = () => {
    if (isLoading) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
          <Loader />
        </div>
      );
    }

    if (!media) return null;

    if (fileType === 'image') {
      return (
        <img 
          src={media?.name ? URL.createObjectURL(media) : media} 
          alt="Preview" 
          height={200} 
          className="img-fluid"
        />
      );
    } else if (fileType === 'video') {
      return (
        <video 
          controls 
          height={200}
          className="img-fluid"
        >
          <source 
            src={media?.name ? URL.createObjectURL(media) : media} 
            type="video/mp4" 
          />
          Your browser does not support the video tag.
        </video>
      );
    }
    return null;
  };

  if (isLoading) {
    return (
      <>
        <Sidebars />
        <Header />
        <main id="main" className="content main mt-0 h-100 min-vh-80">
          <div className="container-fluid allCards-new mobile-image-width mobile-px-0">
            <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
              <Loader />
            </div>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Sidebars />
      <Header />
      <main id="main" className="content main mt-0 h-100 min-vh-80">
        <div className="container-fluid allCards-new mobile-image-width mobile-px-0">
          <div className="row">
            <div className="col-md-12">
              <div className="clearfix mt-3 mb-4">
                <div className="float-start">
                  <h2 className="text-contact">Eligibility For Shopping</h2>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div>
                    <div className="mb-4">
                      <label className="form-label">Image/Video</label>
                      <input
                        type="file"
                        className="form-control"
                        onChange={handleMediaChange}
                        accept="image/*,video/*"
                      />
                      <div className="my-4">
                        <div className="position-relative">
                          {renderMediaPreview()}
                        </div>
                      </div>
                    </div>
                  </div>
                  <form className="form-design" onSubmit={handleSubmit(onSubmit)}>
                    <TextEditor />
                    <Controller
                      name="content"
                      rules={{ required: "Field is required." }}
                      control={control}
                      render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <>
                          <ReactQuill
                            theme="snow"
                            value={value || ''}
                            onChange={(val) => val === "<p><br></p>" ? onChange('') : onChange(val)}
                            placeholder="Enter Terms & Conditions"
                            modules={modules}
                            formats={formats}
                          />
                          {error?.message && <span className="err-msg text-danger">{error.message}</span>}
                        </>
                      )}
                    />
                    <div className="col-md-2 mt-3">
                      <button 
                        type="submit" 
                        className="btn btn-linear btn-block w-100"
                        disabled={isUpdating}
                      >
                        {isUpdating ? <Loader /> : 'Submit'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default EligibilityShopping;